import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import "../styles/CropperPopup.css";
import getCroppedImg from "../components/cropImage";

const CropperPopup = ({ image, onCancel, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropDone = async () => {
    const croppedBlob = await getCroppedImg(image, croppedAreaPixels);
    onCropComplete(croppedBlob);
  };

  const onCropChange = (location) => setCrop(location);

  const onCropAreaComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <div className="cropper-overlay">
      <div className="cropper-content">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={onCropChange}
          onCropComplete={onCropAreaComplete}
          onZoomChange={setZoom}
        />

        <div className="cropper-actions">
          <button onClick={onCancel}>İptal</button>
          <button onClick={onCropDone}>Kaydet</button>
        </div>
      </div>
    </div>
  );
};

export default CropperPopup;
